// Get API URL from runtime config or environment variable
export const getApiUrl = () => {
  // First check runtime config (loaded from config.js)
  if (window.API_CONFIG && window.API_CONFIG.API_URL) {
    return window.API_CONFIG.API_URL;
  }
  
  // Fallback to build-time environment variable
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Default based on current location
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:12343';
  }
  
  // For production, derive from current hostname
  return `${window.location.protocol}//${window.location.hostname.replace('era-classifier', 'era-classifier-api')}`;
};

export const API_URL = getApiUrl();